import axios from 'axios';
import { Exception } from 'sass';

/*
  
para las url externas, hay que manejar los queryparams como base64 con hash
import crypto from "crypto-js";
crypto.SHA512(plain_text).toString()

var encodedStringBtoA = btoa(decodedStringBtoA);
var decodedStringAtoB = atob(encodedStringAtoB);

*/

export class PlantillaService {
    
    async getEtiquetasMenuAuth(idEmpresa, idioma, codMenu, tokenAuth) {

        console.log("getEtiquetasMenuAuth111,");
        if (idEmpresa===0){
            throw new Exception("No hay idEmpresa asociada");
        }
        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        
        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'},
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma':idioma, 'codMenu':codMenu })
        };

        return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/Auth/GetAllEtiquetasMenuAuth',requestOptions).then(res => res.json());
        
    }

    async getEtiquetasMenu(codMenu, idEmpresa, idioma, userName) {

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer "  },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma':idioma, 'userName':userName, 'codMenu':codMenu })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API+'api/v1/Plantilla/GetAllEtiquetasMenu',requestOptions.body);    

        return response.data;
    }

    async getEtiquetasModulo(modulo, idEmpresa, idioma, userName, invocador) {

        if (invocador)
        console.log("invocador,",invocador);
    
        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer "  },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma':idioma, 'userName':userName, 'modulo':modulo })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API+'api/v1/Plantilla/GetAllEtiquetasModulo',requestOptions.body);    

        return response.data;
    }

    async getMenuItems(idEmpresa, idioma, userName, documentoInvitado="") {

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer "  },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma':idioma, 'userName':userName, 'documentoInvitado':documentoInvitado })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API+'api/v1/Plantilla/GetMenuItems',requestOptions.body);    

        return response.data;
    }

}